import React from 'react';

import {
  Actions as UIActions,
  Action,
  PlayArrowIcon,
  StopIcon,
  PendingActionsIcon,
  ContentPasteGoIcon,
  BugReportIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_ARCHIVE,
  ACTION_RESTORE,
  ACTION_MOVE_TO_TEST,
  ACTION_QA,
  ACTION_EDIT,
} from 'scenes/Affiliates/constants';

export const Actions = ({
  actions,
  onArchive,
  onRestore,
  onMoveToTest,
  onQA,
  onEdit,
  onAddComment,
  onViewLog,
  withViewLog,
}) => (
  <Permissions actions={actions}>
    {({ isActionAllowed }) => (
      <UIActions limit={3}>
        <Action
          icon={<PlayArrowIcon />}
          label={'Activate'}
          onClick={onRestore}
          disabled={!isActionAllowed(ACTION_RESTORE)}
        />
        <Action
          icon={<StopIcon />}
          label={'Deactivate'}
          onClick={onArchive}
          disabled={!isActionAllowed(ACTION_ARCHIVE)}
        />
        {withViewLog ? (
          <Action
            id={'view_log'}
            icon={<PendingActionsIcon />}
            label={'View log'}
            onClick={onViewLog}
          />
        ) : null}
        <Action
          disabled={!isActionAllowed(ACTION_MOVE_TO_TEST)}
          icon={<ContentPasteGoIcon />}
          label={'Move to In-Test'}
          onClick={onMoveToTest}
        />
        <Action
          disabled={!isActionAllowed(ACTION_QA)}
          icon={<BugReportIcon />}
          label={'Move to QA'}
          onClick={onQA}
        />
        <Action>
          <Action label={'Add comment'} onClick={onAddComment} />
        </Action>
        <Action
          label={'Edit'}
          disabled={!isActionAllowed(ACTION_EDIT)}
          onClick={onEdit}
        />
      </UIActions>
    )}
  </Permissions>
);
